import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import InputTextField from '../InputTextField';
import InputSelectField from '../InputSelectField';
import InputSelectAutocompleteField from '../InputSelectAutocompleteField';
import InputDateField from '../InputDateField';
import InputDateRangeField from '../InputDateRangeField';
import InputNumberField from '../InputNumberField';
import InputTextAreaField from '../InputTextField';

export default class DynamicForm extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

        const { fields } = this.props;
        let fieldsState = {}
        for(let field of fields) {
          const isDateRange = (field.type === "dateRange" || field.type === "dateRange-mongo");
          fieldsState[field.name] = isDateRange && !field.value ? { $gte: "", $lt: "" } : field.value;
        }
        this.setState((oldState) =>({
          ...oldState,
          ...fieldsState,
      }));

    }

    onSubmit = (event) => {
        if (!!event) {
            event.preventDefault();
        }

        if (this.props.onSubmit) {

            let values = {}

            /* Verify empty objects */
            for(let key of Object.keys(this.state)) {
                const item = this.state[key];

                if(item instanceof Object) {

                    let obj = {}
                    for(let index of Object.keys(item)){
                        let value = item[index];
                        if(!!value) obj[index] = value;
                    }

                    if(Object.entries(obj).length > 0) values[key] = obj

                } else {
                    if(!!item) values[key] = item
                }
            }

            this.props.onSubmit(values);
        }
    };

    clearForm = () => {
        const { fields } = this.props;
        let fieldsState = {};
        for(let field of fields){
          const isDateRange = (field.type === "dateRange" || field.type === "dateRange-mongo");
          fieldsState[field.name] = isDateRange ? { $gte: "", $lt: "" } : "";
          this.setState((oldState) =>({
            ...oldState,
            ...fieldsState,
          }));

        }

        for (let index = 0; index < this.refs.formDynamic.length; index++) {
            const element = this.refs.formDynamic[index];
            if (element) element.value = "";
        }

        this.refs.formDynamic.reset();
    }

    _handleChangeDate = (event, name, type) => {
        const obj = {};

        if (!!event.currentTarget) {
            obj[event.currentTarget.name] = event.currentTarget.value
        } else {
            obj[name] = event;
        }

        const val = obj[name];

        this.setState({
            [name]: val
        });

    }

    _handleNumberChange = (event, name) => {

        const obj = {};

        if (!!event.currentTarget && event.currentTarget.value != null) {
            event.currentTarget.value = event.currentTarget.value.replace(/\D/g, '');
            obj[event.currentTarget.name] = event.currentTarget.value
        } else {
            obj[name] = event;
        }

        this.setState(obj);

    }

    _handleChange = (event, name) => {

        const obj = {};

        if (!!event.currentTarget) {
            obj[event.currentTarget.name] = event.currentTarget.value
        } else {
            obj[name] = event;
        }

        this.setState(obj);
    }

    /* Caso criado para tratar os react-select */
    _handleChangeAutocomplete = (onChange) => (name, value) => {
        const obj = {};
        obj[name] = value;
        this.setState(obj);
        if(!!onChange) {
            onChange(value)
        }
    }

    typeField(field) {
        if (field.type === 'text') {
            return (
                <InputTextField
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    required={!!field.required}
                    mask={field.mask}
                    key={field.name}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    maxLength={field.maxLength}
                    _handleChange={this._handleChange}
                    readonly = {field.readonly}
                    disabled = {field.disabled}
                    value= {this.state[field.name]}
                />
            )
        } else if (field.type === 'select') {
            return (
                <InputSelectField
                    name={field.name}
                    label={field.label}
                    required={field.required}
                    options={field.options}
                    remote={field.remote}
                    key={field.name}
                    value={this.state[field.name]}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    placeholder={field.placeholder}
                    valueInOptionText={field.valueInOptionText}
                    selectFirstIfOnlyOne={field.selectFirstIfOnlyOne}
                    _handleChange={this._handleChange}
                />
            )
        } else if (field.type === 'select-autocomplete') {
            return (
                <InputSelectAutocompleteField
                    name={field.name}
                    label={field.label}
                    required={field.required}
                    options={field.options}
                    remote={field.remote}
                    key={field.name}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    placeholder={field.placeholder}
                    valueInOptionText={field.valueInOptionText}
                    selectFirstIfOnlyOne={field.selectFirstIfOnlyOne}
                    _handleChangeAutocomplete={this._handleChangeAutocomplete(field.onChange)}
                    value={this.state[field.name]}
                />
            )
        } else if (field.type === 'date') {
            return (
                <InputDateField
                    name={field.name}
                    label={field.label}
                    required={field.required}
                    key={field.name}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    _handleChange={this._handleChange}
                    value={this.state[field.name]}
                />
            )
        } else if (field.type === 'dateRange' || field.type === 'dateRange-mongo') {
            return (
                <InputDateRangeField
                    fields={field.fields}
                    value={ this.state[field.name] }
                    name={field.name}
                    key={field.name}
                    _handleChange={this._handleChangeDate}
                />
            )
        } else if (field.type === 'number') {
            return (
                <InputNumberField
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={field.name}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    maxLength={field.maxLength}
                    _handleChange={this._handleNumberChange}
                    value= {this.state[field.name]}
                />
            )
        }else if(field.type === 'textarea'){
            return (
                <InputTextAreaField
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={field.name}
                    sizeSm={field.sizeSm}
                    sizeMd={field.sizeMd}
                    sizeLg={field.sizeLg}
                    _handleChange={this._handleChange}
                    maxLength={field.maxLength}
                    minLength={field.minLength}
                    rows={field.rows}
                    value={this.state[field.name]}
                />
            )
        }
    }

    render() {
        const { fields } = this.props;
        const classRow = !!this.props.classRow ? this.props.classRow : '';
        const isFormRow = !!this.props.isFormRow ? 'form-row' : '';
        return (
            <React.Fragment>
                <form onSubmit={this.onSubmit} ref="formDynamic" className="needs-validation" autoComplete="off">
                    <Col className={isFormRow}>
                        <Row className={classRow}>
                            {fields.map(field => this.typeField(field))}
                            {this.props.children}
                        </Row>
                    </Col>
                </form>
            </React.Fragment>
        );
    }
}
